import { render, staticRenderFns } from "./AddReturnBill.vue?vue&type=template&id=60b2a961&scoped=true"
import script from "./AddReturnBill.vue?vue&type=script&lang=js"
export * from "./AddReturnBill.vue?vue&type=script&lang=js"
import style0 from "./AddReturnBill.vue?vue&type=style&index=0&id=60b2a961&prod&scoped=true&lang=css"
import style1 from "./AddReturnBill.vue?vue&type=style&index=1&id=60b2a961&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b2a961",
  null
  
)

export default component.exports